// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"92652064","225":"c131a96d","904":"ffba722b"}[chunkId] + ".chunk.js";
};